import { RDNaturalDisturbance } from '@cibo/core'
import { EventDetailEditorSimple } from '../EventDetail'
import { DetailEditorPropsByYear } from '../types'
import { NaturalDisturbanceEventEditorSimple } from './NaturalDisturbanceEventEditorSimple'

export const NaturalDisturbanceEditorSimple = ({
  fieldModels,
  year,
  name = 'naturalDisturbance',
  requirement,
  filterInputs,
  traitId,
}: DetailEditorPropsByYear) => (
  <EventDetailEditorSimple<RDNaturalDisturbance['input']>
    traitId={traitId}
    fieldModels={fieldModels}
    year={year}
    name={name}
    requirement={requirement}
    filterInputs={filterInputs}
    EventComponent={NaturalDisturbanceEventEditorSimple}
    translationContext="naturalDisturbance"
    defaultEvent={{ month: '', disturbance: '', lossPer: '' }}
  />
)
